module.exports = {
  custom: require('./custom'),
  events: require('./events'),
  eventDetail: require('./eventDetail'),
  notfound: require('./notfound'),
  plain: require('./plain'),
  text: require('./text'),
}
